module.exports = __webpack_public_path__ + "static/img/binad.8b3d6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/binad.png
// module id = k5wv
// module chunks = 174